(function() {
	'use strict';

	angular
		.module('diplomaApp')
		.controller('completeController', ['$scope', '$timeout', '$http', '$sce', 'dpText', 'dpHelper', completeController]);

	function completeController($scope, $timeout, $http, $sce, dpText, dpHelper) {
		$scope.formData = {};
		$scope.minCount = 1;
		$scope.isString = function(item) { return angular.isString(item); };
		$scope.isArray = function(item) { return angular.isArray(item); };
		$scope.renderHTML = renderHTML;


		function renderHTML(html_code)
		{
			return $sce.trustAsHtml(html_code);
		}

		function initialize() {
			$http.post('/diplomovky/fast_ajax/getCompleteData')
				.then(initializeSuccess);
		}

		function initializeSuccess(response) {
			$scope.sessionData = response.data.sessionData;
			setDefaults($scope.sessionData);
			dpText.set(response.data.texts); 
			dpHelper.step = response.data.step;
			$scope.bindingFile = response.data.sessionData.binding_file;
			console.log($scope.bindingFile);
			setSummary();

			$scope.dpHelper = dpHelper;
			$scope.voucher = dpHelper.getVoucherData($scope.sessionData);
			$scope.minCount = dpHelper.getMinimumCount($scope.voucher, $scope.minCount);

			$timeout(function() {
				$scope.$watch('formData.count', refreshPriceDataWatch);
			});

			function refreshPriceDataWatch(newValue, oldValue) {
				if (newValue !== oldValue) {
					dpHelper.refreshPriceData($scope.formData);
				}
			}
		}

		function setSummary() {
			$http.get('/diplomovky/fast_ajax/getSummary')
				.then(getSummarySuccess);

				function getSummarySuccess(response) {
					$scope.summary = response.data;
					console.log($scope.summary);
				}
		}

		function setDefaults(session) {
			var defaults = {
				count: 'int',
				year: 'string',
				session_id: 'string',
				binding: 'string'
			};

			for (var key in defaults) {
				var type = defaults[key];
				var value = session[key];

				if (typeof value === 'undefined') {
					continue;
				}
				
				if (type === 'int') {
					value = parseInt(value);
				}

				if (type === 'bool') {
					value = (value !== 'false' && value) ? true : false;
				}
				
				$scope.formData[key] = value;
			}
		}

		angular.element(document).ready(function() {
			initialize();
	    });
	}
}());